export const EventLogs = {
  Category: "MerchantConsoleEvents",
  Events: {
    // ADD-ONS
    ADD_ONS_ADD_TO_CART_BUTTON_CLICKED: "AddOnsAddToCartButtonClicked",
    ADD_ONS_OPTIONS_SHOWED: "AddOnsOptionsShowed",
    ADD_ONS_PAGE_LOADED: "AddOnsPageLoaded",
    ADD_ON_SELECTED: "AddOnSelected",
    CHECKING_CUSTOMER_ELIGIBILITY_FOR_ADD_ONS_FAILED:
      "CheckingCustomerEligibilityForAddOnsFailed",
    CUSTOMER_INELIGIBLE_FOR_ADD_ONS: "CustomerIneligibleForAddOns",
    SEND_ADD_ON_NOTIFICATION_ATTEMPTED: "SendAddOnNotificationAttempted",
    SKIP_ADD_ON_SERVICES_CLICKED: "SkipAddOnServicesClicked",

    //ACCEPT A PAYMENT
    INSTORE_PAYMENT_DEVICE_LOOKUP_ATTEMPTED:
      "InstorePaymentDeviceLookupAttempted",
    INSTORE_PAYMENT_CONFIRM_BUTTON_CLICKED:
      "InstorePaymentConfirmedButtonClicked",
    INSTORE_PAYMENT_CUSTOMER_PAID_RECORDED:
      "InstorePaymentCustomerPaidRecorded",
    INSTORE_PAYMENT_DEVICE_LOOKUP_SUCCEEDED:
      "InstorePaymentDeviceLookupSucceeded",

    // BANK SERVICES
    BANK_PROPOSAL_CREATED: "BankProposalCreated",

    //CLERK LOGIN
    CLERK_LOGIN_ATTEMPTED: "ClerkLoginAttempted",
    CLERK_LOGIN_SUCCEEDED: "ClerkLoginSucceeded",

    // DIRECT TO CUSTOMER
    DIRECT_TO_CUSTOMER_WELCOME_PAGE_VISITED:
      "DirectToCustomerWelcomePageVisited",
    DIRECT_TO_CUSTOMER_WELCOME_PAGE_SKIPPED:
      "DirectToCustomerWelcomePageSkipped",
    DIRECT_TO_CUSTOMER_START_SALE_BUTTON_CLICKED:
      "DirectToCustomerStartSaleButtonClicked",
    DIRECT_TO_CUSTOMER_FIND_A_STORE_BUTTON_CLICKED:
      "DirectToCustomerFindAStoreButtonClicked",
    BROWSER_REDIRECTION_POPUP_SHOWN: "BrowserRedirectionPopupShown",
    BROWSER_REDIRECTION_POPUP_URL_COPIED: "BrowserRedirectionPopupUrlCopied",
    BROWSER_REDIRECTION_POPUP_BUTTON_CLICKED:
      "BrowserRedirectionPopupButtonClicked",

    //FACE LOGIN
    FACE_LOGIN_REQUIRED: "FaceLoginRequired",

    //CLERK LOGOUT
    CLERK_LOGGED_OUT: "ClerkLoggedOut",

    //CONTACT
    CUSTOMER_ENTERED_VALID_PHONE: "CustomerEnteredValidPhoneNumber",
    CUSTOMER_ENTERED_VALID_EMAIL: "CustomerEnteredValidEmailAddress",
    CUSTOMER_ENTERED_AN_INVALID_PHONE: "CustomerEnteredInvalidPhoneNumber",
    CUSTOMER_ENTERED_A_PIN_TO_VERIFY_THEIR_PHONE:
      "CustomerEnteredAPinToVerifyTheirPhone",
    CUSTOMER_ENTERED_AN_INVALID_EMAIL_ADDRESS:
      "CustomerEnteredAnInvalidEmailAddress",
    CUSTOMER_PHONE_WAS_FILLED_IN_AND_VERIFIED:
      "CustomerPhoneWasFilledInAndVerified",
    CUSTOMER_PHONE_EDITED: "CustomerPhoneEdited",

    //COMPLETE
    ORDER_SUBMIT: "orderSubmit",
    SOFTWARE_INSTALLATION_RESTARTED: "SoftwareInstallationRestarted",
    DEVICE_TAG_SCREENLOADED: "DeviceTagScreenLoaded",
    DEVICE_TAG_ENTERED: "DeviceTagEntered",
    INVALID_DEVICE_TAG_ERROR_DISPLAYED: "InvalidDeviceTagErrorDisplayed",
    DEVICE_ACTIVATION_STATUS_RETURNED: "DeviceActivationStatusReturned",
    ACTIVATING_DEVICE_ERROR_DISPLAYED: "ActivatingDeviceErrorDisplayed",
    FINANCE_ORDER_CREATED: "FinanceOrderCreated",
    SWAPPING_DEVICE_ERROR_DISPLAYED: "SwappingDeviceErrorDisplayed",

    //CONTRACT
    CONTRACT_SCREEN_LOADED: "ContractScreenLoaded",
    NOT_SIGNED_CONTRACT_LOADED: "NotSignedContractLoaded",
    FAILED_LOAD_CONTRACT: "FailedToLoadContract",
    SIGNED_CONTRACT_LOADED: "SignedContractLoaded",
    CONTRACT_SIGNED: "ContractSigned",
    SIGNED_CONTRACT_DOWNLOADED: "SignedContractDownloaded",
    WELCOME_CALL_STATUS_RETURNED: "WelcomeCallStatusReturned",
    EVERTEC_VOUCHER_GENERATED: "EvertecVoucherGenerated",

    PASSED_WELCOME_CALL_VALIDATION: "ContractPassedWelcomeCallValidation",
    CONTRACT_VERBAL_STATUS_CHANGE: "ContractVerbalStatusChange",
    CONTRACT_PIN_SENT: "ContractPinSent",
    CONTRACT_PIN_ENTERED: "ContractPinEntered",
    CONTRACT_PIN_VALIDATED: "ContractPinValidated",

    //CREDIT CHECK PERMISSIONS
    ESIGN_V1_LOADED: "EsignPadV1Loaded",
    ESIGN_V2_LOADED: "EsignPadV2Loaded",
    CREDIT_PULL_SCREEN_LOADED: "CreditPullScreenLoaded",
    CREDIT_PULL_CONTINUE_BTN_CLICKED: "CreditPullContinueButtonClicked",
    CREDIT_PULL_SCREEN_LEFT: "CreditPullScreenLeft",
    CREDIT_CHECK_PERMISSION_DOC_LOADED: "CreditCheckPermissionDocLoaded",
    CREDIT_CHECK_PERMISSION_CLEARED_ESIGN: "CreditCheckPermissionClearedESign",
    CREDIT_CHECK_PERMISSION_CLICKED_CHECKBOX_OPTION:
      "CreditCheckPermissionClickedCheckbox",
    CREDIT_CHECK_PERMISSION_CLICKED_SMS_OPTION:
      "CreditCheckPermissionClickedSMS",
    CREDIT_CHECK_PERMISSION_ENTERED_ESIGN: "CreditCheckPermissionEnteredESign",
    CREDIT_CHECK_PERMITTED_BY_ESIGN: "CreditCheckPermittedByESign",
    CREDIT_CHECK_PERMITTED_CONFIRMED_PHONE_NO_PIN:
      "CreditCheckPermittedConfirmedByPhoneNoPIN",
    CREDIT_CHECK_CALLED: "CreditCheckCalled",
    QUICK_CREDIT_CHECK_CALLED: "QuickCreditCheckCalled",

    //ID UPLOAD
    IMAGE_UPLOAD_PAGE_DISPLAYED: "ImageUploadPageDisplayed",
    ID_FRONT_UPLOAD_ATTEMPTED: "IdFrontUploadAttempted",
    ID_FRONT_UPLOADED: "IdFrontUploaded",
    ID_BACK_UPLOAD_ATTEMPTED: "IdBackUploadAttempted",
    ID_BACK_UPLOADED: "IdBackUploaded",
    ID_SELFIE_UPLOAD_ATTEMPTED: "IdSelfieUploadAttempted",
    ID_SELFIE_UPLOADED: "IdSelfieUploaded",
    ID_UPLOAD_SUBMIT_CLICKED: "IdUploadSubmitClicked",
    CX_VALIDATION_REQUESTED: "CxValidationRequested",
    ID_PROOF_OF_ADDRESS_UPLOADED: "IdProofOfAddressUploaded",
    ID_PROOF_OF_ADDRESS_UPLOAD_ATTEMPTED: "IdProofOfAddressUploadAttempted",
    ID_UPLOAD_ALLOWABLE_STATUS_RETURNED: "IdUploadAllowableStatusReturned",
    CUSTOMER_ASSISTED: "CustomerAssisted",
    CUSTOMER_ADDRESS_ENTERED: "CustomerAddressEntered",
    CUSTOMER_NEIGHBORNHOOD_ENTERED: "CustomerNeighborhoodEntered",
    CUSTOMER_CITY_SELECTED: "CustomerCitySelected",
    CUSTOMER_POSTAL_CODE_ENTERED: "CustomerPostalCodeEntered",
    CUSTOMER_STATE_SELECTED: "CustomerStateSelected",
    CUSTOMER_ADDRESS_FIELDS_RECORDED: "CustomerAddressFieldsRecorded",
    TRANSCRIBE_ID_SUCCEEDED: "TranscribeIdSucceeded",
    TRANSCRIBE_ID_REQUESTED: "TranscribeIdRequested",

    //INCODE FLOW
    INCODE_IMPORT_FINISHED: "IncodeImportFinished",
    INCODE_ONBOARD: "IncodeOnboard",
    INCODE_IMPORT_STARTED: "IncodeImportStarted",
    INCODE_STATUS: "IncodeStatus",
    INCODE_WITH_FINAL_UUID_RECORDED: "IncodeWithFinalUuidRecorded",
    INCODE_START: "IncodeStart",

    //MERCHANT LOGIN
    MERCHANT_LOGIN_ATTEMPTED: "MerchantLoginAttempted",
    MERCHANT_LOGIN_SUCCEEDED: "MerchantLoginSucceeded",
    RESET_PASSWORD_BUTTON_CLICKED: "ResetPasswordButtonClicked",
    RESET_VALIDATION_SUCCEEDED: "resetValidationSucceeded",
    RESET_VALIDATION_FAILED: "resetValidationFailed",
    FORGOT_PASSWORD_BUTTON_CLICKED: "ForgotPasswordButtonClicked",
    MERCHANT_DETAILS_FETCH_FAILED: "MerchantDetailsFetchFailed",

    //NAV GUARD
    UNAUTHORIZED_PAGE: "UnauthorizedPage",

    // OBR PAGE
    OBR_DEVICES_LIST: "ObrDevicesList",
    OBR_BRAND_FILTER_CLICKED: "ObrBrandFilterClicked",
    OBR_DEVICE_SELECTED: "ObrDeviceSelected",
    OBR_TERM_SELECTED: "ObrTermSelected",
    OBR_CONTINUE_BUTTON_CLICKED: "ObrContinueButtonClicked",
    OBR_SKIP_BUTTON_CLICKED: "ObrSkipButtonClicked",

    //OFFERS
    OFFERS_SCREEN_LOADED: "OffersScreenLoaded",
    CUSTOMER_SENT_TO_CX_FROM_OFFERS: "CustomerSentToCxFromOffers",
    CUSTOMER_NOT_APPROVED_FOR_OFFERS: "CustomerNotApprovedForOffers",
    CUSTOMER_ACTIVE_CREDIT_LINE: "CustomerActiveCreditLine",
    FRAUD_CHECKED: "FraudChecked",
    CHECK_PJVERIFIED: "CheckPjVerified",
    DOWN_PAYMENT_REDUCTION_DATA_RECORDED: "DownPaymentReductionDataRecorded",
    ID_REGISTRATION_DONE: "IdRegistrationDone",
    CART_STATUS_FOR_PRINGING_ELIGIBILITY_RETURNED:
      "CartStatusForPricingEligibilityReturned",
    MANUFACTURER_SELECTED: "ManufacturerSelected",
    DEVICE_FAMILY_SELECTED: "DeviceFamilySelected",
    DEVICE_MODEL_SELECTED: "DeviceModelSelected",
    PRICE_ENTERED: "PriceEntered",
    DOWN_PAYMENT_ENTERED: "DownPaymentEntered",
    DOWN_PAYMENT_VALIDATED: "DownPaymentValidated",
    TERM_OPTIONS_AMOUNT_LOWER_PAYMENT_BADGE:
      "TermOptionsAmountLowerPaymentBadge",
    TERM_OPTIONS_NO_PAYMENT_BADGE: "TermOptionsNoPaymentBadge",
    RECOM_OFFERS_DISPLAYED: "recommendedOffersDisplayed",
    RECOM_OFFERS_CLICKED: "recommendedOffersClicked",
    OUT_OF_RANGE_PRICE_ERROR_DISPLAYED: "OutOfRangePriceErrorDisplayed",
    OUT_OF_RANGE_DOWN_PAYMENT_ERROR_DISPLAYED:
      "OutOfRangeDownPaymentErrorDisplayed",
    PRICE_EDIT_ATTEMPTED: "PriceEditAttempted",
    TERMS_LOADED: "TermsLoaded",
    OFFER_SELECTED: "OfferSelected",
    NUMBER_OF_DEVICE_MANUFACTURERS_OFFERED:
      "NumberOfDeviceManufacturersOffered",
    NUMBER_OF_DEVICE_FAMILIES_OFFERED: "NumberOfDeviceFamiliesOffered",
    NUMBER_OF_DEVICE_MODELS_OFFERED: "NumberOfDeviceModelOffered",
    OFFER_CONTINUE_BUTTON_CLICKED: "OfferContinueButtonClicked ",
    OFFER_CART_DATA_RECORDED: "offerCartDataRecorded",
    PAYJOY_CARD_APPROVED_BANNER_SHOWN: "PayjoyCardApprovedBannerShown",
    PAYJOY_CARD_DISAPPROVED_BANNER_SHOWN: "PayjoyCardDisapprovedBannerShown",
    PAYJOY_CARD_BANNER_CLICKED: "PayjoyCardBannerClicked",

    // ONE-TIME PASSWORD
    ONE_TIME_PASSWORD_GENERATED: "OneTimePasswordGenerated",
    ONE_TIME_PASSWORD_SECTION_DISPLAYED: "OneTimePasswordSectionDisplayed",

    //PRE INSTALL
    PRE_INSTALL_BANNER_BUTTON_CLICKED: "PreInstallBannerButtonClicked",
    PRE_INSTALL_BUTTON_CLICKED: "PreInstallButtonClicked",
    PRE_INSTALL_SAMSUNG_SELECTED: "PreInstallSamsungSelected",
    PRE_INSTALL_OTHER_SELECTED: "PreInstallOtherSelected",
    PRE_INSTALL_SAMSUNG_QR_CODE_DISPLAYED: "PreInstallSamsungQRCodeDisplayed",
    PRE_INSTALL_OTHER_QR_CODE_DISPLAYED: "PreInstallOtherQRCodeDisplayed",
    FAILED_TO_LOAD_QR_CODE: "FailedToLoadQrCode",

    //PURCHASE CONFIRMATION
    DOWN_PAYMENT_COMPLETED: "DownPaymentCompleted",
    DOWN_PAYMENT_REFERENCE_GENERATED: "DownPaymentReferenceGenerated",
    DOWN_PAYMENT_SECTION_DISPLAYED: "DownPaymentSectionDisplayed",
    PAYJOY_VOUCHER_GENERATED: "PayJoyVoucherGenerated",
    PAYJOY_VOUCHER_SECTION_DISPLAYED: "PayJoyVoucherSectionDisplayed",
    PURCHASE_CONFIRMATION_PAGE_CONTINUE_BTN_CLICKED:
      "PurchaseConfirmationPageContinueBtnClicked",
    PURCHASE_CONFIRMATION_PAGE_DISPLAYED: "PurchaseConfirmationPageDisplayed",

    //QUICK APPROVAL FLOW
    ESIGN_AND_PHONE_PAGE_DISPLAYED: "EsignAndPhonePageDisplayed",
    BACK_ID_SELFIE_QR_DISPLAYED: "BackIdSelfieQRDisplayed",
    BACK_ID_SELFIE_UPLOAD_COMPLETED: "BackIdSelfieUploadCompleted",
    BACK_ID_SELFIE_UPLOAD_PAGE_DISPLAYED: "BackIdSelfieUploadPageDisplayed",
    FACE_LOGIN_CAPTURE_DISPLAYED: "FaceLoginCaptureDisplayed",
    ESIGN_AND_PHONE_PAGE_CONTINUE_BTN_CLICKED:
      "EsignAndPhonePageContinueBtnClicked",
    SECOND_QR_SESSION_SUCCESS_CONTINUE_BTN_CLICKED:
      "SecondQRSessionSuccessContinueBtnClicked",

    CREDIT_CHECK_PERMISSION_DROPDOWN_CLICKED:
      "CreditCheckPermissionDropdownClicked",
    CREDIT_CHECK_PERMISSION_BY_SMS_RECORDED:
      "CreditCheckPermissionBySMSRecorded",
    CREDIT_CHECK_PERMISSION_ESIGN_AUTO_FILLED:
      "CreditCheckPermissionESignAutoFilled",
    CREDIT_CHECK_PERMISSION_ESIGN_DRAWN: "CreditCheckPermissionESignDrawn",
    CREDIT_CHECK_PERMISSION_SMS_PHONE_NUMBER_VALIDATED:
      "CreditCheckPermissionSMSPhoneNumberValidated",
    CREDIT_CHECK_PERMISSION_SMS_VERIFICATION_PIN_ENTERED:
      "CreditCheckPermissionSMSVerificationPinEntered",
    CREDIT_CHECK_PERMISSION_SMS_VERIFIED: "CreditCheckPermissionSMSVerified",
    FRONT_ID_QR_DISPLAYED: "FrontIdQRDisplayed",
    FRONT_ID_UPLOAD_PAGE_DISPLAYED: "FrontIdUploadPageDisplayed",
    FRONT_ID_UPLOAD_COMPLETED: "FrontIdUploadCompleted",
    FACE_LOGIN_CAPTURE_COMPLETED: "FaceLoginCaptureCompleted",
    FACE_LOGIN_CAPTURE_ERROR: "FaceLoginCaptureError",
    FACE_LOGIN_VERIFIED: "FaceLoginVerified",
    FACE_LOGIN_NO_MATCH: "FaceLoginNoMatch",

    //RECEIPT PAGE
    RECEIPT_LOADED: "ReceiptLoaded",
    RATE_EXPERIENCE_RATE_SELECTED: "RateExperienceRateSelected",
    TEXT_FEEDBACK_BY_CLERK_SUBMITTED: "TextFeedbackByClerkSubmitted",

    //SELF SERVICE
    ENABLE_SELF_SERVED_BUTTON_CLICKED: "EnableSelfServedButtonClicked",
    FINISH_SALE_BUTTON_CLICKED: "FinishSaleButtonClicked",
    SELF_SERVICE_ACTIVE_VERIFIED: "SelfServiceActiveVerified",
    SELF_SERVICE_RATE_EXPERIENCE_CLICKED: "SelfServiceRateExperienceClicked",
    SELF_SERVICE_BAD_RATE_EXPERIENCE_SENT: "SelfServiceBadRateExperienceSent",
    SELF_SERVICE_SURVEY_USED: "SelfServiceSurveyUsed",
    SELF_SERVICE_SURVEY_SKIPPED: "SelfServiceSurveySkipped",
    SELF_SERVICE_SURVEY_RECOMMEND_DEVICE_FAILED:
      "SelfServiceSurveyRecommendDeviceFailed",
    SELF_SERVICE_SURVEY_RESULTS: "SelfServiceSurveyResults",
    SELF_SERVICE_CANCEL_SALE_SURVEY_RESULTS:
      "SelfServiceCancelSaleSurveyResults",

    //SESSION EXPIRED
    SESSION_EXPIRED: "SessionExpired",

    //SOFTWARE
    SOFTWARE_INSTALL_PAGE: "SoftwareInstallPage",
    SOFTWARE_INSTALL_WIZARD_STARTED: "SoftwareInstallWizardStarted",
    DEVICE_PHONE_ENTERED: "DevicePhoneEntered",
    CUSTOMER_CART_DISPLAYED: "CustomerCartDisplayed",
    IMEI_SOFTWARE_FLOW: "IMEISoftwareFlow",
    QR_CODE_SOFTWARE_FLOW: "QrcodeSoftwareFlow",
    SIDE_LOAD_SOFTWARE_FLOW: "SideLoadSoftwareFlow",
    SOFTWARE_INSTRUCTIONS_SKIPPED: "SoftwareInstructionsSkipped",
    DLC_SOFTWARE_FLOW: "DLCSoftwareFlow",
    ZENDESK_HELP_PAGE_CLICKED: "ZendeskHelpPageClicked",
    ZENDESK_HELP_PAGE_BUTTON_CLICKED: "ZendeskHelpPageButtonClicked",

    // SUSPICIOUS ACTIVITY
    SUSPICIOUS_ACTIVITY: "SuspiciousActivity",
    SUSPICIOUS_ACTIVITY_POST_FAIL: "SuspiciousActivityPostFail",

    //TERM CONDITIONS AND PRIVACY
    TERMS_AND_CONDITIONS_LOADED: "TermsAndConditionsLoaded",
    PRIVACY_POLICY_LOADED: "PrivacyPolicyLoaded",
    TERMS_AND_CONDITIONS_DROPDOWN_CLICKED: "TermsAndConditionsDropdownClicked",
    PRIVACY_POLICY_DROPDOWN_CLICKED: "PrivacyPolicyDropdownClicked",
    TERMS_AND_CONDITIONS_AND_PRIVACY_POLICY_ACCEPTANCE_ATTEMPTED:
      "TermsAndConditionsAndPrivacyPolicyAcceptanceAttempted",
    TERMS_AND_CONDITIONS_ACCEPTANCE_RECORDED:
      "TermsAndConditionsAcceptanceRecorded",
    PRIVACY_POLICY_ACCEPTANCE_RECORDED: "PrivacyPolicyAcceptanceRecorded",
    TC_VIEW: "TCview",
    TC_CONTINUE: "TCcontinue",

    //WAIT FOR VALIDATION
    CUSTOMER_CX_VALIDATION_APPROVED: "CustomerCXValidationApproved",
    CUSTOMER_CX_VALIDATION_DECLINED: "CustomerCXValidationDeclined",

    //WELCOME PAGE
    SELL_PHONE_BUTTON_CLICKED: "SellPhoneButtonClicked",
    CART_CREATED: "CartCreated",
    CART_MILESTONE_CREATED: "CartMilestoneCreated",
    ACCEPT_PAYMENT_BUTTON_CLICKED: "AcceptPaymentButtonClicked",
    GET_MY_PHONE_BUTTON_CLICKED: "GetMyPhoneButtonClicked",

    //IMEI Page
    IMEI_PAGE_LOADED: "ImeiPageLoaded",

    //QR LOGIN
    QR_LOGIN_DETECT_MOBILE: "QrLoginDetectMobile",
    CHECK_CLERK_SESSION_STATUS: "CheckClerkSessionStatus",
    LOGIN_QR_CODE_DISPLAYED: "LoginQrCodeDisplayed",
    QR_LOGIN_SESSION_AUTHENTICATED: "QrLoginSessionAuthenticated",
    QR_LOGIN_SESSION_CX_REJECTED: "QrLoginSessionCxRejected",
    QR_LOGIN_SESSION_CX_APPROVED: "QrLoginSessionCxApproved",
    ERROR_QR_LOGIN_SESSION_EXPIRED: "ErrorQrLoginSessionExpired",
    QR_LOGIN_SHOW_LOGIN_INTRO: "QrLoginShowLoginIntro",
    QR_LOGIN_SHOW_SUCCESS_LOGIN: "QrLoginShowSuccessLogin",
    QR_LOGIN_SHOW_TAKE_SELFIE_INTRO: "QrLoginShowTakeSelfieIntro",
    QR_LOGIN_GO_TO_FACE_LOGIN: "QrLoginGoToFaceLogin",
    QR_LOGIN_INCODE_CAPTURE_VIEW: "QrLoginIncodeCaptureView",
    QR_LOGIN_INCODE_CAPTURE_SUCCESS: "QrLoginIncodeCaptureSuccess",
    QR_LOGIN_INCODE_CAPTURE_FACEMATCH_REJECTED:
      "QrLoginIncodeCaptureFaceMatchRejected",
    QR_LOGIN_INCODE_CAPTURE_RETRY: "QrLoginIncodeCaptureRetry",
    QR_LOGIN_SHOW_INCODE_CAPTURE: "QrLoginShowIncodeCapture",
    QR_LOGIN_DISPLAY_CX_REVIEWING_PAGE: "QrLoginDisplayCxReviewingPage",
    SHOW_CLERK_REGISTRATION: "QrLoginShowClerkRegistration",
    SUBMITTED_CLERK_REGISTRATION: "QrLoginSubmittedClerkRegistration",
    SUBMIT_CLERK_REGISTRATION_ERROR: "SubmitClerkRegistrationError",
    QR_LOGIN_INCODE_CAPTURE_FACEMATCH_APPROVED:
      "QrLoginIncodeCaptureFaceMatchApproved",
    QR_LOGIN_SESSION_CREATED: "QrLoginSessionCreated",
    QR_LOGIN_SESSION_ERROR: "QrLoginSessionError",
    VALIDATE_STORED_JWT: "ValidateStoredJWT",
    ERROR_VALIDATE_STORED_JWT: "ErrorValidateStoredJWT",
    CLERK_SIGN_IN: "ClerkSignIn",
    CLERK_SIGN_IN_ERROR: "ClerkSignInError",
    CLERK_AUTH_IDENTITY: "ClerkAuthIdentity",
    CLERK_AUTH_IDENTITY_ERROR: "ClerkAuthIdentityError",
    QR_LOGIN_CLERK_AUTHENTICATED: "QrLoginClerkAuthenticated",
    FACE_LOGIN_VERIFY_ERROR: "FaceLoginVerifyError",
    QR_LOGIN_POLL_STATUS_ERROR: "QrLoginPollStatusError",

    // E-commerce
    ECOMMERCE_ONBOARDING: "EcommerceOnboarding",
    ECOMMERCE_INCODE: "EcommerceIncode",
    ECOMMERCE_CONTACT_INFO: "EcommerceContactInfo",
    ECOMMERCE_CONTACT_INFO_PHONE: "EcommerceContactInfoPhone",
    ECOMMERCE_CONTACT_INFO_EMAIL: "EcommerceContactInfoEmail",
    ECOMMERCE_BUREAU_CONSULT: "EcommerceBureauConsult",
    ECOMMERCE_BUREAU_CONSULT_SIGNATURE: "EcommerceBureauConsultSignature",
    ECOMMERCE_REJECTED_ANOTHER_METHOD: "EcommerceRejectedAnotherMethod",
    ECOMMERCE_REJECTED_ANOTHER_METHOD_EXIT:
      "EcommerceRejectedAnotherMethodExit",
    ECOMMERCE_OFFERS: "EcommerceOffers",
    ECOMMERCE_OFFERS_SELECTION: "EcommerceOffersSelection",
    ECOMMERCE_OFFERS_SELECTION_ERROR: "EcommerceOffersSelectionError",
    ECOMMERCE_CONTRACT: "EcommerceContract",
    ECOMMERCE_CONTRACT_SIGNATURE: "EcommerceContractSignature",
    ECOMMERCE_CONTRACT_MAKE_DOWN_PAYMENT: "EcommerceContractMakeDownPayment",
    ECOMMERCE_CONTRACT_BACK: "EcommerceContractBack",
    ECOMMERCE_DOWN_PAYMENT_TRIGGER: "EcommerceDownPaymentTrigger",
    ECOMMERCE_DOWN_PAYMENT_SUCCESS: "EcommerceDownPaymentSuccess",
    ECOMMERCE_QRCODE_SCAN: "EcommerceQrcodeScan",
    ECOMMERCE_API_START_SUCCESS: "EcommerceApiStartSuccess",
    ECOMMERCE_API_RETURN_SUCCESS: "EcommerceApiReturnSuccess",
    ECOMMERCE_CANCELED: "EcommerceCanceled",
    ECOMMERCE_HELP_PAGE_CLICKED: "EcommerceHelpPageClicked",
    // Miscellanenous
    ECOMMERCE_CART_TERMINATE_SALE_CUSTOMER_INFO:
      "EcommerceCartTerminateSaleCustomerInfo",
    ECOMMERCE_CART_TERMINATE_SALE_WAIT_VALIDATION:
      "EcommerceCartTerminateSaleWaitValidation",
    ECOMMERCE_ERROR_SETTING_PRICE: "EcommerceErrorSettingPrice",
    ECOMMERCE_LOADING_ENTER: "EcommerceLoadingEnter",
    ECOMMERCE_LOADING_SUCCESS: "EcommerceLoadingSuccess",
    ECOMMERCE_CONTACT_INFO_CONTINUE: "EcommerceContactinfoContinue",
    ECOMMERCE_LOADING_ERROR: "EcommerceLoadingError",

    // In Console Training
    TRAINING_ARTICLES_SHOWN: "TrainingArticlesShown",
    TRAINING_ARTICLES_HIDDEN: "TrainingArticlesHidden",
    LONG_TRAINING_ARTICLE_SHOWN: "LongTrainingArticleShown",
  },
};

export interface IEventLogDataObject {
  merchantId?: string;
  clerkId?: string;
  cartId?: string;
  userId?: string;
}
export default EventLogs;
